import { render, staticRenderFns } from "./DashboardLinksPaginationButton.vue?vue&type=template&id=0ee4a0b4&"
import script from "./DashboardLinksPaginationButton.vue?vue&type=script&lang=js&"
export * from "./DashboardLinksPaginationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports